import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="px-6 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">Top Categories</h3>
            <ul className="space-y-2">
              <li><Link to="/courses?category=Development" className="hover:text-white cursor-pointer">Development</Link></li>
              <li><Link to="/courses?category=Business" className="hover:text-white cursor-pointer">Business</Link></li>
              <li><Link to="/courses?category=Design" className="hover:text-white cursor-pointer">Design</Link></li>
              <li><Link to="/courses?category=Marketing" className="hover:text-white cursor-pointer">Marketing</Link></li>
              <li><Link to="/courses?category=IT & Software" className="hover:text-white cursor-pointer">IT & Software</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/courses" className="hover:text-white cursor-pointer">All Courses</Link></li>
              <li><Link to="/instructor" className="hover:text-white cursor-pointer">Become an Instructor</Link></li>
              <li><Link to="/my-learning" className="hover:text-white cursor-pointer">My Learning</Link></li>
              <li><a href="#" className="hover:text-white cursor-pointer">About Us</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white cursor-pointer">Help Center</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer">Terms of Service</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer">Cookie Policy</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer">Sitemap</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Connect With Us</h3>
            <div className="flex gap-4 mb-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
            <div className="text-sm">
              <p className="mb-2">Download our app</p>
              <div className="flex gap-2">
                <a href="#" className="cursor-pointer">
                  <img src="https://readdy.ai/api/search-image?query=apple%20app%20store%20download%20badge%20button%2C%20black%20background%20with%20white%20text%2C%20official%20apple%20design%2C%20clean%20simple%20style&width=120&height=40&seq=appstore&orientation=landscape" alt="App Store" className="h-10" />
                </a>
                <a href="#" className="cursor-pointer">
                  <img src="https://readdy.ai/api/search-image?query=google%20play%20store%20download%20badge%20button%2C%20colorful%20design%20with%20play%20icon%2C%20official%20google%20design%2C%20clean%20simple%20style&width=120&height=40&seq=playstore&orientation=landscape" alt="Google Play" className="h-10" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800 px-6 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm">
            © 2024 LearnHub, Inc. All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white cursor-pointer">
              Powered by Readdy
            </a>
            <div className="flex gap-4">
              <i className="ri-global-line text-xl cursor-pointer hover:text-white"></i>
              <span className="text-sm">English</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
